import { DashboardContainer } from "./components/DashboardComponents"

export const UserReviews = () => {
     return(
          <DashboardContainer>
               <h2>User  Reviews</h2>
          </DashboardContainer>
     )
}